import { render, staticRenderFns } from "./CategoriesDetails.vue?vue&type=template&id=3d1a926c&scoped=true"
import script from "./CategoriesDetails.vue?vue&type=script&lang=js"
export * from "./CategoriesDetails.vue?vue&type=script&lang=js"
import style0 from "./CategoriesDetails.vue?vue&type=style&index=0&id=3d1a926c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1a926c",
  null
  
)

export default component.exports